import { render, staticRenderFns } from "./editGift.vue?vue&type=template&id=0415c09c&scoped=true&"
import script from "./editGift.vue?vue&type=script&lang=js&"
export * from "./editGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0415c09c",
  null
  
)

export default component.exports